import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgSurvey(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31 32.14a6 6 0 0 1 6-6h46.903a6 6 0 0 1 6 6V96a6 6 0 0 1-6 6H37a6 6 0 0 1-6-6V32.14Z"
        fill="#007A5F"
      />
      <path
        d="M35.243 33.524a3 3 0 0 1 3-3H82.66a3 3 0 0 1 3 3v60.982a3 3 0 0 1-3 3H38.243a3 3 0 0 1-3-3V33.524Z"
        fill="#fff"
      />
      <path
        d="M77.737 80.66a.8.8 0 0 1 0 1.601H53.73a.8.8 0 0 1 0-1.6h24.008Zm0-6.53a.8.8 0 0 1 0 1.6H53.73a.8.8 0 0 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H53.73a.8.8 0 0 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H53.73a.8.8 0 0 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H53.73a.8.8 0 1 1 0-1.6h24.008Zm0-6.53a.8.8 0 1 1 0 1.6H53.73a.8.8 0 1 1 0-1.6h24.008Z"
        fill="#B3C0D0"
      />
      <path
        d="M48.235 52.171c0-.188-.023-.372-.063-.55l-1.99 1.96a.8.8 0 0 1-1.123 0l-.853-.84a.8.8 0 0 1 1.122-1.14l.292.287 1.693-1.667a2.631 2.631 0 0 0-1.693-.611c-1.456 0-2.615 1.159-2.615 2.561 0 1.403 1.16 2.56 2.615 2.56 1.455 0 2.615-1.157 2.615-2.56Zm1.6 0c0 2.31-1.9 4.161-4.215 4.161-2.316 0-4.214-1.851-4.214-4.16 0-2.31 1.898-4.162 4.214-4.162 1.09 0 2.087.41 2.838 1.084l.869-.855a.8.8 0 0 1 1.123 1.141l-1.023 1.005a4.1 4.1 0 0 1 .407 1.786ZM48.235 64.655c0-.188-.023-.372-.063-.55l-1.991 1.96a.8.8 0 0 1-1.122 0l-.854-.84a.8.8 0 0 1 1.123-1.14l.291.287 1.694-1.667a2.632 2.632 0 0 0-1.694-.611c-1.455 0-2.614 1.159-2.614 2.561 0 1.403 1.159 2.56 2.614 2.56 1.456 0 2.616-1.157 2.616-2.56Zm1.6 0c0 2.31-1.9 4.161-4.215 4.161-2.316 0-4.214-1.851-4.214-4.16 0-2.31 1.898-4.162 4.214-4.162 1.089 0 2.087.41 2.837 1.084l.87-.854a.8.8 0 0 1 1.123 1.14l-1.023 1.005a4.1 4.1 0 0 1 .407 1.786ZM48.235 78.1c0-.189-.023-.373-.063-.55l-1.991 1.96a.8.8 0 0 1-1.122 0l-.854-.84a.8.8 0 0 1 1.123-1.14l.291.287 1.694-1.667a2.631 2.631 0 0 0-1.694-.612c-1.455 0-2.614 1.16-2.614 2.562s1.159 2.56 2.614 2.56c1.456 0 2.616-1.158 2.616-2.56Zm1.6 0c0 2.31-1.9 4.16-4.215 4.16-2.316 0-4.214-1.85-4.214-4.16s1.898-4.161 4.214-4.161c1.089 0 2.087.41 2.837 1.084l.87-.855a.8.8 0 0 1 1.123 1.14l-1.023 1.006a4.1 4.1 0 0 1 .407 1.786Z"
        fill="#78B441"
      />
      <path
        d="M65.414 21a1.2 1.2 0 0 0-1.2-1.2H57.65a1.2 1.2 0 0 0-1.2 1.2v3.683a1.2 1.2 0 0 0 1.2 1.2h6.563a1.2 1.2 0 0 0 1.2-1.2V21Zm1.6 3.683a2.8 2.8 0 0 1-2.8 2.8H57.65a2.8 2.8 0 0 1-2.8-2.8V21a2.8 2.8 0 0 1 2.8-2.8h6.563a2.8 2.8 0 0 1 2.8 2.8v3.683Z"
        fill="#0F172A"
      />
      <path
        d="M50.849 24.881a3 3 0 0 1 3-3h13.206a3 3 0 0 1 3 3v5.524a3 3 0 0 1-3 3H53.848a3 3 0 0 1-3-3V24.88Z"
        fill="#78B441"
      />
      <path
        d="M47.968 33.405a2.881 2.881 0 0 1 2.88-2.881h19.207a2.881 2.881 0 0 1 0 5.762H50.848a2.881 2.881 0 0 1-2.88-2.881Z"
        fill="#78B441"
      />
      <path d="M71.015 29.724a.8.8 0 1 1 0 1.6H54.69a.8.8 0 1 1 0-1.6h16.325Z" fill="#0F172A" />
    </svg>
  )
}
export default wrapIllustration(SvgSurvey)
